import { MobileMenuComponentType } from './menu';

export enum PlayerTemplate {
    INIT = 'INIT',
    DEFAULT = 'Default',
    VIDEO_CHAT = 'VideoChat',
    VIDEO_ONLY = 'Video'
}

export type LayoutStyles = {
    viewerClasses?: string;
    gridClasses?: string;
    contentLayoutClasses?: string;
    chatLayoutClasses?: string;
    ctaLayoutClasses?: string;
    pollLayoutClasses?: string;
};

export type LayoutState = {
    chapterActive: boolean;
    chatActive: boolean;
    slidesActive: boolean;
    participantsActive: boolean;
    pollsActive: boolean;
    onMobileMenuItemClicked: (componentType: MobileMenuComponentType) => void;
    styles?: LayoutStyles;
};

const initLayoutState: LayoutState = {
    chapterActive: false,
    chatActive: false,
    slidesActive: false,
    participantsActive: false,
    pollsActive: false,
    onMobileMenuItemClicked: () => {},
    styles: {
        viewerClasses: `max-h-custom-100vh min-h-mh-viewer`,
        gridClasses:
            'relative switch:min-h-fit grid grid-cols-default switch:grid-cols-default-lg grid-rows-default switch:grid-rows-default-lg gap-x-[var(--grid-gap)]',
        contentLayoutClasses:
            'col-start-1 switch:col-start-2 row-start-2 switch:row-start-1 row-end-3 switch:min-w-[var(--min-content-width)] switch:max-w-[var(--max-content-width)] min-h-0 grid grid-cols-content grid-rows-content switch:grid-rows-default-content-lg filler',
        chatLayoutClasses: 'col-start-1 row-start-1 switch:row-start-3',
        ctaLayoutClasses: 'col-start-1 row-start-2 hidden switch:block',
        pollLayoutClasses: 'col-start-1 row-start-1 switch:row-end-4'
    }
};

const getDefaultLayoutState = (isMobile = false): LayoutState => {
    return {
        chapterActive: true,
        chatActive: true,
        slidesActive: true,
        participantsActive: true,
        pollsActive: true,
        onMobileMenuItemClicked: () => {},
        styles: {
            viewerClasses: `w-fit h-fit max-h-custom-100vh min-h-mh-viewer`,
            gridClasses: `relative grid ${
                isMobile
                    ? `w-full h-viewer max-h-[980px] grid-cols-default grid-rows-default`
                    : `w-fit h-fit min-h-fit grid-cols-default-lg grid-rows-default-lg`
            } gap-x-[var(--grid-gap)]`,
            contentLayoutClasses: `${
                isMobile
                    ? `col-start-1 row-start-2 row-end-4 grid-rows-content`
                    : `col-start-2 row-start-1 min-w-[var(--min-content-width)] max-w-[var(--max-content-width)] grid-rows-default-content-lg`
            } row-end-3 min-h-0 max-h-full grid grid-cols-content filler`,
            chatLayoutClasses: `col-start-1 ${isMobile ? `row-start-1` : `row-start-3`}`,
            ctaLayoutClasses: `col-start-1 row-start-2 ${isMobile ? `hidden` : ``}`,
            pollLayoutClasses: `col-start-1 row-start-1 row-end-4`
        }
    };
};
const getVideoChatLayoutState = (isMobile = false): LayoutState => {
    return {
        chapterActive: false,
        chatActive: true,
        slidesActive: false,
        participantsActive: false,
        pollsActive: false,
        onMobileMenuItemClicked: () => {},
        styles: {
            viewerClasses: ``,
            gridClasses: `${isMobile ? `w-full h-viewer max-h-[980px]` : `w-fit h-fit min-h-fit `} grid grid-cols-videochat grid-rows-videochat`,
            contentLayoutClasses: 'col-start-1 row-start-2 row-end-3 min-h-0 max-h-full grid grid-cols-content grid-rows-videochat-content',
            chatLayoutClasses: 'col-start-1 row-start-2',
            ctaLayoutClasses: 'col-start-1 row-start-1',
            pollLayoutClasses: 'col-start-1 row-start-1 row-end-3'
        }
    };
};

const videoOnlyLayoutState: LayoutState = {
    chapterActive: false,
    chatActive: false,
    slidesActive: false,
    participantsActive: false,
    pollsActive: false,
    onMobileMenuItemClicked: () => {},
    styles: {
        viewerClasses: ``,
        gridClasses: `relative w-fit h-fit grid grid-cols-videochat grid-rows-videoonly`,
        contentLayoutClasses: 'col-start-1 row-start-2 row-end-3 min-h-0 grid grid-cols-content grid-rows-videoonly-content',
        ctaLayoutClasses: 'col-start-1 row-start-1'
    }
};

export type LayoutStates = {
    initLayoutState: LayoutState;
    getDefaultLayoutState: (isMobile: boolean) => LayoutState;
    getVideoChatLayoutState: (isMobile: boolean) => LayoutState;
    videoOnlyLayoutState: LayoutState;
};

export const layouts: LayoutStates = {
    initLayoutState: initLayoutState,
    getDefaultLayoutState,
    getVideoChatLayoutState,
    videoOnlyLayoutState: videoOnlyLayoutState
};
